// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__D-CQv","validationTips":"StatementDescriptor_validationTips__Xew23"};